import { useQuery } from '@tanstack/react-query';
import { pnidApi } from '../api';
import { queryKeys } from '../queries/keys';

/** Whether Groq endpoint detection is configured and ready for this deployment. */
export function useGroqVisionStatus(): boolean {
  const query = useQuery({
    queryKey: queryKeys.groqVisionStatus(),
    queryFn: async () => {
      const status = await pnidApi.getGroqVisionStatus();
      return status.ready;
    },
    staleTime: Infinity,
  });

  return query.data ?? false;
}
